// Un lien direct de la barre du bas (Polymarket, Blog, Connexion, Inscription)
// est actif quand le chemin courant est le sien, ou une de ses sous-pages pour
// les sections listées.
const SECTION_PREFIXES = ['/dashboard', '/prediction_markets', '/graph_analyses', '/simulations', '/account', '/blog']

const pathOf = (url: string): string => url.replace(/^[a-z][a-z\d+.-]*:\/\/[^/?#]*/i, '').split(/[?#]/, 1)[0] || '/'

export function isActiveFromUrl(currentUrl: string, href: string): boolean {
  const currentPath = pathOf(currentUrl)
  const linkPath = pathOf(href)
  return currentPath === linkPath || SECTION_PREFIXES.some((p) => linkPath === p && currentPath.startsWith(p))
}
